export enum PacketType {
  AUTH = "AUTH",
  CORE_DATA = "CORE_DATA",
  PLAY_MUSIC = "PLAY_MUSIC",
  PLAY_EFFECT = "PLAY_EFFECT",
  VOLUME = "VOLUME",
  ONBOARD_MUSIC = "ONBOARD_MUSIC",
  PRELOAD = "PRELOAD",
  AREA_ENTER = "AREA_ENTER",
  AREA_UPDATE = "AREA_UPDATE",
  AREA_LEAVE = "AREA_LEAVE",
  AUDIO_MUFFLE_MANIPULATION = "AUDIO_MUFFLE_MANIPULATION",
  RIDEPHOTO = "RIDEPHOTO",
  FAILED_AUTH = "FAILED_AUTH",
  DISCONNECT = "DISCONNECT",
  INBOUND_CLIENT_CONNECTION = "INBOUND_CLIENT_CONNECTION",
  INBOUND_CLIENT_DISCONNECT = "INBOUND_CLIENT_DISCONNECT",
  PING = "PING",
  INBOUND_CLIENT_WARP = "INBOUND_CLIENT_WARP",
  AREA_SYNC = "AREA_SYNC",
}
